export const BOOTSTRAP_LARGE_BREAKPOINT_MEDIA_QUERY = "(min-width: 992px)";

export const GENDERLESS_POKEMON = [
  "magnemite",
  "magneton",
  "voltorb",
  "electrode",
  "staryu",
  "starmie",
  "porygon",
  "porygon2",
  "shedinja",
  "lunatone",
  "solrock",
  "baltoy",
  "claydol",
  "beldum",
  "metang",
  "metagross",
  "bronzor",
  "bronzong",
  "magnezone",
  "porygon-z",
  "rotom",
  "phione",
  "manaphy",
  "klink",
  "klang",
  "klinklang",
  "cryogonal",
  "golett",
  "golurk",
  "carbink",
  "minior",
  "dhelmise",
  "sinistea",
  "polteageist",
  "falinks",
  "tandemaus",
  "maushold",
];

export const DITTO = { name: "ditto", dexNumber: 132 };

export const NO_EGGS = {
  name: "no-eggs",
  url: "https://pokeapi.co/api/v2/egg-group/no-eggs",
};

export const EGG_GROUP_CSS_VARIABLES = {
  monsterBorder: "#933846",
  humanlikeBorder: "#93695b",
  water1Border: "#697fb1",
  water2Border: "#506caf",
  water3Border: "#3d5285",
  bugBorder: "#77881d",
  mineralBorder: "#554439",
  flyingBorder: "#7c6caf",
  amorphousBorder: "#606060",
  fieldBorder: "#9d8649",
  fairyBorder: "#b38ca8",
  dittoBorder: "#744686",
  grassBorder: "#5b933f",
  dragonBorder: "#552eb3",
  noeggsBorder: "#232323",
  monsterColor: "210, 80, 100",
  humanlikeColor: "210, 150, 130",
  water1Color: "151, 181, 253",
  water2Color: "114, 154, 250",
  water3Color: "88, 118, 190",
  bugColor: "170, 194, 42",
  mineralColor: "122, 98, 82",
  flyingColor: "178, 154, 250",
  amorphousColor: "138, 138, 138",
  fieldColor: "224, 192, 104",
  fairyColor: "255, 200, 240",
  dittoColor: "166, 100, 191",
  grassColor: "130, 210, 90",
  dragonColor: "122, 66, 255",
  noeggsColor: "51, 51, 51",
};
